import { render, staticRenderFns } from "./SaudeBucal.vue?vue&type=template&id=ba319616"
import script from "./SaudeBucal.vue?vue&type=script&lang=js"
export * from "./SaudeBucal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports